import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar";
import UpdateProjectTagForm
	from "~/modules/admin/components/AdminView/components/AdminProjectTagsSection/components/UpdateProjectTagSidebar/components/UpdateProjectTagForm";
import { ALL_PROJECT_TAGS_QUERY_KEY } from "~/modules/project/api/projectTag/projectTagQueries.ts";
import type { ProjectTag, ProjectTagTypeId } from "~/modules/project/api/projectTag/projectTagTypes.ts";

type UpdateDeliverableTagSidebarProps = {
	isOpen: boolean;
	onClose: () => void;
	projectTagData: ProjectTag | null,
	tagTypeId: ProjectTagTypeId;
};

const UpdateProjectTagSidebar: FunctionComponent<UpdateDeliverableTagSidebarProps> = ({
	isOpen,
	onClose,
	projectTagData,
	tagTypeId,
}) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: ALL_PROJECT_TAGS_QUERY_KEY });
		onClose();
	}, [onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			{isOpen && projectTagData && <UpdateProjectTagForm onSuccess={handleSuccess}
															   onCancel={onClose}
															   projectTagData={projectTagData}
															   tagTypeId={tagTypeId}
			/>}
		</Sidebar>
	);
};

export default UpdateProjectTagSidebar;
